<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">溯源管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item>
                    <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search"
                               @click="submitQuery(1)">刷新
                    </el-button>
                    <el-button type="primary" size="small" @click="openUpload">
                        导入溯源
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <hr/>
        <div class="title">
            <span>溯源列表</span>
        </div>
        <div class="content-data">
            <el-table highlight-current-row :data="sellers" border>
                <el-table-column align="center" label="序号" type="index"/>
                <el-table-column align="center" label="编号" prop="code"/>
                <el-table-column align="center" label="产品名称" prop="productName"/>
                <el-table-column align="center" label="产地" prop="placeOrigin"/>
                <el-table-column align="center" label="净含量" prop="weight"/>
                <el-table-column align="center" label="生产日期" prop="productionTime"/>
                <el-table-column align="center" label="保质期" prop="qualityGuaranteePeriod"/>
                <el-table-column align="center" label="存储条件" prop="storageConditions"/>
                <el-table-column align="center" fixed="right" label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini"
                                   @click="deleteTraceability(scope.row.id )">
                            删除
                        </el-button>
                        <el-button type="info" size="mini" icon="el-icon-download"
                                   @click="downloadQrcode(scope.row.qrcodePath,scope.row.code)">
                            下载
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <traceability-upload :success="success" ref="traceability-upload"></traceability-upload>
        <vue-pager :datafile="fillData" url="/traceability/pageTraceability" :query="query" ref="pager"
                   :init="true"></vue-pager>
    </div>
</template>
<script>
    import traceabilityUpload from '@/components/traceabilityUpload.vue';

    export default {
        data() {
            return {
                query: {},
                sellers: []
            }
        },
        components: {
            traceabilityUpload,
        },
        methods: {
            fillData(_response) {
                this.sellers = _response.items || [];
            },
            submitQuery(_num) {
                this.$refs.pager.gotoPage(_num);
            },
            success() {
                if (this.$refs.pager) {
                    this.submitQuery(1);
                }
            },
            downloadQrcode(_path, _code) {
                let a = document.createElement('a');
                a.setAttribute("href", config.dynamicResourcePath + _path);
                a.setAttribute("download", _code);
                a.click();
            },
            deleteTraceability: function (_traceabilityId) {
                var _this = this;
                _this.$confirm('是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$common.ajaxRequest({
                        url: '/traceability/deleteTraceability',
                        data: {
                            traceabilityId: _traceabilityId
                        },
                        success(response) {
                            _this.$message({
                                message: '删除成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function () {
                                    _this.submitQuery();
                                }
                            });
                        }
                    })
                }).catch(() => {
                    console.log('delete cancel');
                });
            },
            openUpload() {
                this.$refs["traceability-upload"].openDialog();
            }
        },
    }
</script>